import React, { Component } from "react";
import { Header, Icon, Image } from "semantic-ui-react";

class HeaderInfo extends Component {
  render() {
    return (
      <Header as="h2">
        <Image circular src="/static/images/gerard_formal.jpg" />
        <Header.Content>
          Hi, I'm Gerard Gueco
          <Header.Subheader>
            Front End Developer
            <br></br>
            <p className="location">
              <Icon name="map marker alternate" />
              Manila, Philippines
            </p>
          </Header.Subheader>
        </Header.Content>
      </Header>
    );
  }
}

export default HeaderInfo;
